import { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { MessagesTypes, CREDIT_APP_SOURCE_ID } from '../constants';
import { submitCreditApp } from '../store/actionCreators';

/**
 * Custom hook to handle credit app iframe messages
 * Sets up message event listener and dispatches Redux actions
 * Filters messages by sourceId and processes them accordingly
 */
export const useCreditAppMessages = () => {
    const dispatch = useDispatch();

    const handleMessages = useCallback(
        (event: MessageEvent) => {
            const { context, message } = event.data;

            switch (context) {
                case MessagesTypes.CONFIRMATION_PAGE: {
                    dispatch(submitCreditApp(message.creditAppId, message.dealRefId, message.shopper));
                    break;
                }
                default:
                    break;
            }
        },
        [dispatch]
    );

    const handleIframeRequest = useCallback(
        (event: MessageEvent) => {
            if (event.data?.sourceId !== CREDIT_APP_SOURCE_ID) return;
            if (event.data.context) handleMessages(event);
        },
        [handleMessages]
    );

    useEffect(() => {
        window.addEventListener('message', handleIframeRequest as EventListener, false);
        return () => {
            window.removeEventListener('message', handleIframeRequest as EventListener, false);
        };
    }, [handleIframeRequest]);
};
